import {
  FETCH_DRIVERS_REQUEST,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  UPDATE_DRIVER_STATUS_REQUEST,
  UPDATE_DRIVER_STATUS_SUCCESS,
  UPDATE_DRIVER_STATUS_FAILURE,
  FETCH_DRIVER_WALLETS_REQUEST,
  FETCH_DRIVER_WALLETS_SUCCESS,
  FETCH_DRIVER_WALLETS_FAILURE,
  ADMIN_TOP_UP_WALLET_REQUEST,
  ADMIN_TOP_UP_WALLET_SUCCESS,
  ADMIN_TOP_UP_WALLET_FAILURE,
} from "../actions/types";

const initialState = {
  drivers: {
    data: [],
  },

  wallets: [],

  loading: false,
  error: null,
  message: "",

  page: 1,
  hasMore: true,
  total: 0,
};

export default function driverReducer(
  state = initialState,
  action
) {
  switch (action.type) {

    case FETCH_DRIVERS_REQUEST:
    case UPDATE_DRIVER_STATUS_REQUEST:
    case FETCH_DRIVER_WALLETS_REQUEST:
    case ADMIN_TOP_UP_WALLET_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };

case FETCH_DRIVERS_SUCCESS: {
    const {
        data,
        page,
        pages,
        total,
    } = action.payload;

    return {
        ...state,

        loading: false,

        drivers: {
            data: data || [],
        },

        page: page || 1,

        hasMore:
            page < pages,

        total:
            total || 0,

        message:
            "Drivers loaded successfully",
    };
}

    case FETCH_DRIVER_WALLETS_SUCCESS:

      return {
        ...state,

        loading: false,

        wallets:
          action.payload,

        message:
          "Driver wallets loaded successfully",
      };


    case UPDATE_DRIVER_STATUS_SUCCESS: {

      const updatedDriver =
        action.payload;

      return {
        ...state,

        loading: false,

        drivers: {
          ...state.drivers,

          data:
            Array.isArray(
              state.drivers?.data
            )
              ? state.drivers.data.map(
                  (driver) =>
                    driver.driver_id ===
                    updatedDriver.driver_id
                      ? {
                          ...driver,
                          ...updatedDriver,
                        }
                      : driver
                )
              : [],
        },

        message:
          "Driver status updated successfully",
      };
    }


    case ADMIN_TOP_UP_WALLET_SUCCESS:

      return {
        ...state,

        loading: false,

        message:
          "Driver wallet topped up successfully.",
      };


    case FETCH_DRIVERS_FAILURE:
    case UPDATE_DRIVER_STATUS_FAILURE:
    case FETCH_DRIVER_WALLETS_FAILURE:
    case ADMIN_TOP_UP_WALLET_FAILURE:

      return {
        ...state,

        loading: false,

        error:
          action.payload,
      };


    default:
      return state;
  }
}